import { render } from "./AptWrapperView.vue?vue&type=template&id=7f5d8b10&ts=true"
import script from "./AptWrapperView.vue?vue&type=script&lang=ts"
export * from "./AptWrapperView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__